import React, { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

// ── Ricerca riusabile (Messaggi interni oggi, Ticket/Supporto domani) ──

export const useDebouncedValue = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

// Accent-folding condiviso col backend: perche = perché
const ACCENT_GROUPS = ["aàáâãäå", "eèéêë", "iìíîï", "oòóôõö", "uùúûü", "cç", "nñ", "yýÿ"];
const ACCENT_MAP = {};
ACCENT_GROUPS.forEach((g) => {
  const cls = `[${g}${g.toUpperCase()}]`;
  [...g].forEach((ch) => { ACCENT_MAP[ch] = cls; });
});
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
export const accentPattern = (q) =>
  [...(q || "").toLowerCase()].map((ch) => ACCENT_MAP[ch] || escapeRe(ch)).join("");

/** Evidenzia le occorrenze di `query` in `text` (case+accent-insensitive). */
export const Highlight = ({ text, query }) => {
  const t = text ?? "";
  if (!query || query.length < 2) return <>{t}</>;
  let parts;
  try {
    parts = t.split(new RegExp(`(${accentPattern(query)})`, "gi"));
  } catch {
    return <>{t}</>;
  }
  return (
    <>
      {parts.map((p, i) =>
        i % 2 === 1
          ? <mark key={i} className="bg-accent/25 text-inherit rounded-[2px] px-px">{p}</mark>
          : <React.Fragment key={i}>{p}</React.Fragment>
      )}
    </>
  );
};

export const SearchBar = ({ value, onChange, placeholder = "Cerca…", testId = "search-bar", autoFocus = false }) => (
  <div className="relative w-full" data-testid={testId}>
    <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
      data-testid={`${testId}-input`}
      className="wl-input w-full pl-9 pr-9 h-10 text-sm"
      aria-label={placeholder}
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange("")}
        data-testid={`${testId}-clear`}
        aria-label="Svuota ricerca"
        className="absolute right-2.5 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-subtle text-text-muted"
      >
        <X size={14} />
      </button>
    )}
  </div>
);
